<script>
export default {
    name: 'SlideArrows',
    props: {
        visible: Boolean,
        moduleType: {
            type: String,
            required: true
        },
    },
    template: `
    <transition name="slide" mode="out-in" v-show="visible">
        <nav class="slide__arrows" aria-label="Primary">
            <transition name="fade-left" mode="out-in">
                <button-more
                    v-show="visible && current"
                    type="prev"
                    text="Previous"
                    label="Previous slide"
                    @click.native="$root.$emit('slide-goto', current - 1)"
                />
            </transition>
            <transition name="fade-right">
                <button-more
                    v-show="visible && notLast"
                    type="next"
                    text="Next"
                    label="Next slide"
                    @click.native="$root.$emit('slide-goto', current + 1)"
                />
            </transition>
        </nav>
    </transition>`,
    computed: {
        current() {
            const { getters } = this.$store
            return getters[`${this.moduleType}/currentSlide`]
        },
        notLast() {
            const { getters } = this.$store
            return this.current < getters[`${this.moduleType}/slides`].length - 1
        },
    }
}
</script>
